import { isElectronApp } from '#~/electron/utils.js';
import { DataSTag, Sel } from '#~/stag/index.js';
import type { Props } from './types.js';
import { Button } from '@studio/design-system/button';
import { Icon } from '@studio/design-system/icon';
import { Centered } from '@studio/design-system/overlay';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';

/** `<Bulletin>` component. */
export const Bulletin = ({ className, icon, message, ...props }: Props): ReactElement => (
  // Per rule: playwright-stag-selectors-only (platform) — identify boundary takeovers without matching copy.
  <Centered className='px-8 text-xl leading-150' {...props} {...DataSTag(Sel.Error, 'bulletin')}>
    <div className={twMerge('flex items-center gap-8', className)}>
      {!!icon && <Icon className='mr-px' icon={icon} />} {message}
    </div>
    {isElectronApp() && (
      <a href='/'>
        <Button>Go to home page</Button>
      </a>
    )}
  </Centered>
);
